export default {"src":"/_next/static/media/PREVIEW_PROJECT_DISABLED.36519f16.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};